module.exports = __webpack_public_path__ + "static/img/business-license.328409a3.png";